var map = {
	"./DESAYUNO_1.jpeg": 619,
	"./SERENATA_1.jpeg": 953,
	"./amistad.jpg": 346,
	"./arreglo_globos.jpg": 736,
	"./charros.jpg": 173,
	"./desayuno_mixto.png": 242,
	"./salmon.jpg": 996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;